import { CategoryEntension } from '../catalog/catalog-extension.model';

export class Image extends CategoryEntension
{
  category: string;
  extension: string;
  isError: boolean;
  messageError: string;
}
